import type { IConfig } from './configEnv.interface';

// Configuration for the Bus Line Recorder public site — Coding (local API)
//
// The API host FOLLOWS THE BROWSER instead of being hardcoded, which is the one
// real difference from busLineApp's config (there, a native app has no "current
// page" to derive a host from, hence its long list of commented-out LAN IPs).
//
// Why it matters: opened at http://localhost:5174 the API is localhost:5040, but
// opened from a phone at http://192.168.1.29:5174 `localhost` would mean *the
// phone*. Deriving the host from window.location makes both work with no edit
// when the LAN IP changes.
//
// The API port is fixed at 5040 (busLineApi configEnv.code.ts `httpPort`), and
// whatever origin you serve this from still has to be in that file's
// cors.accConAllowOrigin.
const API_PORT = 5040;

const localApiBaseUrl = (): string => {
    // SSR/test safety: no window means fall back to loopback.
    if (typeof window === 'undefined') return `http://localhost:${API_PORT}`;
    const { protocol, hostname } = window.location;
    return `${protocol}//${hostname}:${API_PORT}`;
};

export const configEnvCode: IConfig = {
    name: 'coding',

    api: {
        baseUrl: localApiBaseUrl(),
        timeout: 15000,
    },

    debug: {
        enabled: true,
        logLevel: 'debug',
    },
};
